import React from "react";
import { Collapse } from 'reactstrap';
import { withLocalize, Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { IndexLabel } from "../../common/semaphors";
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import HistoryLink from "../../common/historyLink";

class IndexHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            isExpandedTouched: false,
            items: this.props.data
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({
                isExpandedTouched: false,
                items: this.props.data
            });
        }
    }

    render() {
        if (this.state.items.length > 0) {
            return (
                <React.Fragment>
                    <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)} onClick={this.expand} />
                    <Collapse isOpen={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)}>
                        <table
                            className={`table table-condensed table-report-section ${this.state.items.length > 3 ? "has-pseudo" : ""}`}
                            style={{borderCollapse:"collapse", width:"100%"}}
                        >
                            <thead>
                                <tr>
                                    <th className="one-quarter">Index Cribis</th>
                                    <th className="one-quarter"><Translate id="Report.Common.ValidFrom" /></th>
                                    <th className="one-quarter"><Translate id="Report.Common.ValidTo" /></th>
                                    <th className="one-quarter"><Translate id="Report.Common.Note" /></th>
                                    {this.state.items.length > 3 && <th className="pseudo-column"></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.items.map((d, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className="one-quarter"><IndexLabel index={d.index} code={d.code}></IndexLabel> </td>
                                            <td className="one-quarter">{d.startFormated}</td>
                                            <td className="one-quarter">{d.endFormated}</td>
                                            <td className="one-quarter">{(d.type === "S0") ? <Translate id="Report.Ratings.IndexType.S0" /> : <Translate id="Report.Ratings.IndexType.S1" />}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </Collapse>
                </React.Fragment>
            )
        }
        return (
            ""
        )
    }

    expand = () =>
        this.setState({
            expanded: !this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched),
            items: this.props.data,
            isExpandedTouched: true
        })
}

export default withLocalize(connect(
    state => state.report, dispatch => bindActionCreators(reportActions, dispatch)
)(IndexHistory));